var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"artic-list"},_vm._l((_vm.list),function(item,index){return _c('artic-item',{key:index,attrs:{"item":_vm.list[index]},on:{"update:item":function($event){return _vm.$set(_vm.list, index, $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }